import { IdMap } from "@gtmhub/util";
import { IBuildSessionTreeContext, ISessionSelectorContext, ISessionTreeNode } from "@webapp/sessions/models/session-tree.model";
import { Session } from "@webapp/sessions/models/sessions.model";
import { SessionSelectorUtilsService } from "../session-selector-utils.service";

export abstract class AbstractSessionTreeBuilder {
  protected sessionIdMap: IdMap<Session>;

  constructor(protected sessionSelectorUtilsService: SessionSelectorUtilsService) {}

  public abstract buildTree(sessions: Session[], context: ISessionSelectorContext): ISessionTreeNode[];
  protected abstract findHostNode(nodes: ISessionTreeNode[], parentSessionId?: string): ISessionTreeNode;

  public setSessionIdMap(map: IdMap<Session>): void {
    this.sessionIdMap = map;
  }

  protected createSessionTreeNode(sessionId: string, context: IBuildSessionTreeContext): ISessionTreeNode {
    const session = context.sessions.find((s) => s.id === sessionId);
    const sessionItem: ISessionTreeNode = {
      key: sessionId,
      title: session.title,
      color: session.color,
      isHostSession: !!(context.hostSessionId && sessionId === context.hostSessionId),
      disabled: !session.userHasPermissionToCreate,
    } as ISessionTreeNode;
    this.setChildrenPropertiesToSessionItem(sessionItem, { hostSessionId: context.hostSessionId, sessions: context.sessions });

    return sessionItem;
  }

  protected setChildrenPropertiesToSessionItem(sessionItem: ISessionTreeNode, context: IBuildSessionTreeContext): void {
    sessionItem.children = [];
    const childSessionsIds = context.sessions
      .filter((s) => s.parentId === sessionItem.key)
      .sort(this.sessionSelectorUtilsService.byEndDescAndStartAsc)
      .map((cs) => cs.id);

    if (!childSessionsIds.length) {
      sessionItem.hasChildHostSession = false;
      return;
    }

    childSessionsIds.forEach((childSessionId) => {
      sessionItem.children.push(this.createSessionTreeNode(childSessionId, { sessions: context.sessions, hostSessionId: context.hostSessionId }));
    });

    sessionItem.hasChildHostSession = !!(context.hostSessionId && this.sessionSelectorUtilsService.isAnyChild(sessionItem, (c) => c.key === context.hostSessionId));
  }
}
